import { ManufacturingOrderPageable } from '../manufacturing-order-pageabe';
import { ManufacturingOrderBuilder } from './manufacturing-order.builder';

export class ManufacturingOrderPageableBuilder {
  static fromJson(json) {
    return json
      ? new ManufacturingOrderPageable(
          ManufacturingOrderBuilder.fromList(json.manufacturingOrders),
          json.totalPage,
          json.total
        )
      : null;
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/builders/manufacturing-order-pageable.builder.ts